/**
 * 格式化日期时间
 * @param {Object} format 日期格式
 * yyyy=年；M,MM=月；d,dd=日；dddd=星期；
 * H,HH=小时；m,mm=分钟；s,ss=秒；
 * S=毫秒；Q=季度
 * 例如：yyyy年MM月dd日 dddd HH:mm:ss S
 * 
 * console.log(new Date().format("yyyy年MM月dd日 dddd HH:mm:ss"));
 */
Date.prototype.format = function(format) {
	let weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
	let o = {
		"y+": this.getFullYear(), //年
		"M+": this.getMonth() + 1, //月份
		"d+": this.getDate(), //日
		"h+": this.getHours(), //小时
		"m+": this.getMinutes(), //分
		"s+": this.getSeconds(), //秒
		"S": this.getMilliseconds(), //毫秒
		"ddd+": this.getDay(), //星期
		"Q": Math.floor((this.getMonth() + 3) / 3), //季度
	};
	for (let k in o) {
		if (k == "y+" && new RegExp("(" + k + ")", "i").test(format)) { //年
			format = format.replace(RegExp.$1, (o[k] + "").substr(4 - RegExp.$1.length));
		} else if (k == "ddd+" && new RegExp("(" + k + ")", "i").test(format)) { //星期
			format = format.replace(RegExp.$1, (RegExp.$1.length == 3) ? (o[k]) : (weekArr[o[k]]));
		} else if (new RegExp("(" + k + ")", (k == "M+" || k == "m+" ? "" : "i")).test(format)) {
			format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
				.length)));
		}
	}
	return format;
}

/**
 * 获取从 n 到 m 的随机数
 * @param {Object} n 最小数（包含）
 * @param {Object} m 最大数（不包含）
 */
export function getRandom(n, m) {
	return Math.floor(Math.random() * (m - n) + n);
	// return Math.floor(Math.random() * (m - n + 1) + n); // 包含最大值
}

/**
 * 根据 日期 获取 多少天后 的日期
 * @param {Object} date 初始日期
 * @param {Object} days 几天后或几天前(负数)
 */
export function getLaterdays(date, days) {
	let dTime = new Date(date).getTime() + days * 24 * 60 * 60 * 1000;
	return new Date(dTime).format("yyyy-MM-dd");
}

/**
 * 获取两个日期间隔天数，开始日期和结束日期 部分先后
 * @param {Object} startDate 开始日期
 * @param {Object} endDate 结束日期
 */
export function getDateInterval(startDate, endDate) {
	let date1 = new Date(new Date(startDate).format("yyyy-MM-dd") + " 00:00:00");
	let date2 = new Date(new Date(endDate).format("yyyy-MM-dd") + " 00:00:00");
	return Math.ceil(Math.abs(date1.getTime() - date2.getTime()) / 86400000);
}



/**
 * 从URL中获取参数，在mock中模拟get请求时获取参数
 * @param {Object} url
 */
export function getUrlParam(url) {
	const search = url.split('?')[1]
	if (!search) return {}
	return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') +
		'"}')
}
